import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { LoadingService } from 'src/app/loading.service';
import { Book } from '../book';
import { BooksService } from '../books.service';
import { bookValidator } from './book-validation.directive';
import { AuthorsService } from 'src/app/author-group/authors.service';
import { Observable, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-new-book',
  templateUrl: './new-book.component.html',
  styleUrls: ['./new-book.component.css']
})
export class NewBookComponent {
  constructor(private formBuilder: FormBuilder, private booksService: BooksService, private loadingService: LoadingService, private authorService: AuthorsService) {}

  selectedFile?: File = undefined
  fileName = '';

  bookForm = this.formBuilder.group({
    title: [''],
    summary: [''],
    author: [''],
    purchaseLink: [''],
  }, {validators: bookValidator})

  authors = [...this.authorService.lastAuthorBatch!!.map(function (author) { return `${author.lastName}, ${author.firstName}` })]
 
  searchAuthors: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(10),
      distinctUntilChanged(),
      map((term) =>
        this.authors.filter((v) => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10),
      ),
    );

  onSubmit() {
    const newBook = ({uid: undefined, title: this.bookForm.value.title, summary: this.bookForm.value.summary, author: this.bookForm.value.author, purchaseLink: this.bookForm.value.purchaseLink }) as Book
    const loadingKey = newBook.title
    this.loadingService.addLoadingKey(loadingKey)
    this.booksService.addNewBook(newBook, loadingKey, this.selectedFile)
  }

  cancelClicked() {
    this.booksService.addBookCancelled()
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (file.type == "image/png" || file.type == "image/jpeg") {
        this.fileName = file.name;
        this.selectedFile = file
      } else {
        alert(`Error: Invalid File Type - ${file.name}`)
        return
      }
    }
  }

  removeFile() {
    this.selectedFile = undefined
    this.fileName = ""
  }
}


